import { Component, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { AuthServiceService } from "../../../shareModule/services/auth-service.service";
import { LocalServiceService } from "../../../shareModule/services/local-service.service";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "src/environments/environment";

@Component({
    selector: 'app-forum-profile-popup',
    templateUrl: './profile-popup.component.html',
    styleUrls: ['./profile-popup.component.scss']
})
export class ForumProfilePopupComponent implements OnInit {
    constructor(
        private router: Router,
        private local: LocalServiceService,
        private auth: AuthServiceService,
        private toastr: ToastrService,
        private modalService: NgbModal,
        private route: ActivatedRoute,
        private spinner: NgxSpinnerService,
        private formBuilder: FormBuilder) { }

    @Input() user: any;


    private modalRef: any;
    isLogin: any = 0;
    isLoading: boolean = false;
    appUserId: any;
    categories: any = [];
    imgUrl = environment.ImageUrl

    ngOnInit() {
        const getUser = this.local.getUser();

        if (getUser) {
            this.appUserId = getUser.id;
        }

        (getUser) ? this.isLogin = 1 : 0;
    }

    ngOnDestroy(): void {
    }

}
